import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { environment } from '../../../../environments/environment';
import { CardsConfig } from '../../../const/cards-config';
import { Months } from '../../../const/months';
import { CardConfig } from '../../../interfaces/cardConfig';
import { CCityI } from '../../../interfaces/cards-locations/c_citiy';
import { CCountryI } from '../../../interfaces/cards-locations/c_country';
import { CStateI } from '../../../interfaces/cards-locations/c_state';
import { DirectDebitService } from '../../../services/direct-debit.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-card-collect',
  templateUrl: './card-collect.component.html',
  styleUrls: ['./card-collect.component.scss']
})
export class CardCollectComponent implements OnInit {

  @Output() closeModal = new EventEmitter();
  @Output() submitCard = new EventEmitter();
  @Input() disableLocations: boolean;
  @Input() ownerName: string;
  // @ViewChild('compInfo') compInfo :

  public cardForm: FormGroup;
  public cardConf = CardsConfig;
  public cardConfig: CardConfig;
  public months = Months;
  public validYears: any[];
  public samePerson = false;
  public countries: CCountryI[] = [];
  public states: CStateI[] = [];
  public cities: CCityI[] = [];
  public c_FilterCities: CCityI[];
  public otherCity = false;
  public cn1Value = [];
  public showCardComplementForm = false;
  public panelOpenState = false;
  public saveBtnText = 'Add Card';
  filterControl = new FormControl();

  public minValidDate = moment().format('YYYY-MM-DD');

  private prod = environment.production;

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private directDebitService: DirectDebitService,
  ) { }

  ngOnInit() {
    this.validYears = this.getYears();
  }

  private getYears() {
    const years = [];
    const dateStart = moment();
    const dateEnd = moment().add(10, 'y');
    while (dateEnd.diff(dateStart, 'years') >= 0) {
      years.push(dateStart.format('YYYY'));
      dateStart.add(1, 'year');
    }
    return years;
  }

  initCardForm() {
    this.cardForm = this.formBuilder.group({
      c_name: ['', [Validators.required]],
      c_cn1: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_cn2: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_cn3: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_cn4: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_month: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_year: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_code: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      c_type: ['', [Validators.required]],
      c_address: [''],
      c_country: [''],
      c_state: [''],
      c_city: [''],
      c_zip: ['']
    });
  }

  async fillCardForm(data?) {
    this.initCardForm();
    if (!data) {
      this.saveBtnText = 'Add Card';
    } else {
      this.saveBtnText = 'Save Card';
    }
    // await this.getCountries();
    this.cardForm.setValue({
      c_name: data && data.c_name ? data.c_name : null,
      c_cn1: data && data.c_cn1 ? parseInt(data.c_cn1, 10)  : null,
      c_cn2: data && data.c_cn2 ? parseInt(data.c_cn2, 10) : null,
      c_cn3: data && data.c_cn3 ? parseInt(data.c_cn3, 10) : null,
      c_cn4: data && data.c_cn4 ? parseInt(data.c_cn4, 10) : null,
      c_month: data && data.c_month ? data.c_month : null,
      c_year: data && data.c_year ? data.c_year : null,
      c_code: data && data.c_code ? data.c_code : null,
      c_type: data && data.c_type ? data.c_type : null,
      c_address: (data && data.c_address) ? data.c_address : null,
      c_country: (data && data.c_country) ? data.c_country : null,
      c_state: (data && data.c_state) ? data.c_state : null,
      c_city: (data && data.c_city) ? data.c_city : null,
      c_zip: (data && data.c_zip) ? data.c_zip : null
    });
    if (data && data.c_name) {
      this.samePerson = true;
    }
    if (data && data.c_country) {
      await this.getStates(data.c_country);
      this.cardForm.controls.c_state.setValue(data.c_state);
    }
    if (data && data.c_state) {
      await this.getCities(data.c_state);
      this.cardForm.controls.c_city.setValue(data.c_city);
    }
    if (data && data.c_address) {
      this.panelOpenState = true;
    }
    this.checkProcessPayment();
  }

  changeInputMax(value) {
    this.cardConfig = this.cardConf.find((x) => x.desc === value);
    this.cardForm.controls.c_cn4.setValue(null);
    this.cardForm.controls.c_code.setValue(null);

    if (this.cardForm.controls.c_type.value !== 'DINERS CLUB') {
      this.cardForm.controls.c_type.setValue(this.cardConfig.desc);
    }
  }

  // Función para manejar si el usuario da enter y pasar al siguiente input
  keytab(event, _maxLength) {
    // tratamos de predecir que tipo de tarjeta es
    if (event.srcElement.id === 'c_cn1') {
      let cardType: CardConfig[];

      const valueEnter = event.target.value;

      if (!valueEnter) {
        this.cn1Value = [];
      } else {
        const numValue = valueEnter;
        this.cn1Value = [];

        for (let i = 0; i < numValue.length - 1; i++) {
          this.cn1Value[i] = numValue[i];
        }

        this.cn1Value.push(numValue);

        cardType = this.cardConf.filter((x) => {
          const element = x.divine;

          const results = element.filter((n) => {
            for (let i = 0; i < this.cn1Value.length; i++) {
              return n[i].includes(this.cn1Value[i]);
            }
          });
          return results.length;
        });

        if (cardType && cardType.length > 0) {
          this.changeInputMax(cardType[0].desc);
        } else {
          if (this.cardForm.controls.c_type.value !== 'DINERS CLUB') {
            this.cardForm.controls.c_type.setValue(null);
            this.cardForm.controls.c_type.markAsTouched();
          }
        }
      }
    }

    // return;
    if (
      event.srcElement.id === 'c_cn1' &&
      event.target.value.length === _maxLength
    ) {
        document.getElementById('c_cn2').focus();
      }
    if (
        event.srcElement.id === 'c_cn2' &&
        event.target.value.length === _maxLength
      ) {
        document.getElementById('c_cn3').focus();
      }
    if (
        event.srcElement.id === 'c_cn3' &&
        event.target.value.length === _maxLength
      ) {
        document.getElementById('c_cn4').focus();
      }

  }

  //#region Direct Debit Section
  async getCountries() {
    try {
      const query = await this.directDebitService.getCountries().toPromise();
      if (query.ok) {
        this.countries = query.countries;
      }
    } catch (e) {
      this.messageService.printStatusArray(e.error.errors, 'error');
    }
  }

  async getStates(countryName: string) {
    const country: CCountryI = this.countries.find(x => x.name === countryName);
    if (country) {
      this.states = null;
      this.cities = null;
      this.c_FilterCities = null;
      this.cardForm.controls.c_state.setValue(null);
      try {
        const query = await this.directDebitService.getStates(country.id).toPromise();
        if (query.ok) {
          this.states = query.states;
        }
      } catch (e) {
        this.messageService.printStatusArray(e.error.errors, 'error');
      }
    } else {
      return;
    }
  }

  async getCities(stateName: string) {
    const cState: CStateI = this.states.find(x => x.name === stateName);
    if (cState) {
      try {
        const query = await this.directDebitService.getCities(cState.code).toPromise();
        if (query.ok) {
          this.cities = query.cities;
          this.c_FilterCities = query.cities;
        }
      } catch (e) {
        this.messageService.printStatusArray(e.error.errors, 'error');
      }
    } else {
      return;
    }
  }

  checkProcessPayment() {
    if (this.disableLocations === true) {
      this.showCardComplementForm = false;
      this.disableEnableCardLocations(true);
    }

    if (this.disableLocations === false) {
      this.showCardComplementForm = true;
      this.disableEnableCardLocations(false);
    }
  }

  disableEnableCardLocations(disable: boolean) {
    if (disable === true) {
      this.cardForm.controls.c_address.disable();
      this.cardForm.controls.c_country.disable();
      this.cardForm.controls.c_state.disable();
      this.cardForm.controls.c_city.disable();
      this.cardForm.controls.c_zip.disable();
    }
    if (disable === false) {
      this.cardForm.controls.c_address.enable();
      this.cardForm.controls.c_country.enable();
      this.cardForm.controls.c_state.enable();
      this.cardForm.controls.c_city.enable();
      this.cardForm.controls.c_zip.enable();
    }
  }

  onPanelClose() {
    this.c_FilterCities = this.cities;
    this.filterControl.setValue('');
  }

  filtrar(value) {
    const filterValue = value.toLowerCase();
    this.c_FilterCities = this.cities.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  enabledOtherCity($event) {
    // if ($event === '313750') {
    //   console.log($event)
    //   this.otherCity = true;
    // } else {
    //   this.otherCity = false;
    // }
  }
  //#endregion

  //#endregion

  public getOwner(cardHolder?: boolean) {
    if (cardHolder && cardHolder === true && this.ownerName) {
      this.samePerson = true;
      this.cardForm.controls.c_name.setValue(this.ownerName);
    }
    if (cardHolder === false) {
      this.samePerson = false;
    }
  }

  onClose() {
    this.closeModal.emit();
  }

  submitCardData() {

    if (this.cardForm.invalid) {
      this.messageService.printStatus('Review the form, some input are required to procced', 'warning');
      this.cardForm.markAllAsTouched();
      return;
    }
    const cardData = this.cardForm.value;
    const c_number =
      String(cardData.c_cn1) +
      String(cardData.c_cn2) +
      String(cardData.c_cn3) +
      String(cardData.c_cn4);

    const card = {
      c_number,
      c_name: cardData.c_name,
      c_cn1: cardData.c_cn1,
      c_cn2: cardData.c_cn2,
      c_cn3: cardData.c_cn3,
      c_cn4: cardData.c_cn4,
      c_month: cardData.c_month,
      c_year: cardData.c_year,
      c_code: cardData.c_code,
      c_type: cardData.c_type,
      c_address: (cardData.c_address) ? cardData.c_address : null,
      c_country: (cardData.c_country) ? cardData.c_country : null,
      c_state: (cardData.c_state) ? cardData.c_state : null,
      c_city: (cardData.c_city) ? cardData.c_city : null,
      c_zip: (cardData.c_zip) ? cardData.c_zip : null,
    };
    this.submitCard.emit(card);
  }
}
